import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  any: 'Perioada',
  from: 'De la',
  to: 'Până la',
  fromValue: 'De la {{date}}',
  toValue: 'Până la {{date}}',
  clear: 'Golește perioada',
  calendar: 'Alege data',
  previousMonth: 'Luna anterioară',
  nextMonth: 'Luna următoare',
  openCalendar: 'Deschide calendarul pentru „{{field}}”',
  invalidDate: 'Scrieți data ca DD/MM/YYYY.',
} as const;

const en = {
  any: 'Period',
  from: 'From',
  to: 'To',
  fromValue: 'From {{date}}',
  toValue: 'Until {{date}}',
  clear: 'Clear period',
  calendar: 'Choose a date',
  previousMonth: 'Previous month',
  nextMonth: 'Next month',
  openCalendar: 'Open the calendar for “{{field}}”',
  invalidDate: 'Enter the date as DD/MM/YYYY.',
} satisfies Translation<keyof typeof ro>;

export const dateRangeFilter = { ro, en } satisfies Dictionary;

export type DateRangeFilterKey = keyof typeof ro;
